import React from 'react';

import Store from '../metadata/components/technician-schedules/Store';
import Controller from '../metadata/components/technician-schedules/Controller';
import queryString from '../utils/QueryString';

export default function (api, socket, opts, match) {
    // @TODO use query passed in from router
    var queryParams = queryString.parse(window.location.search);
    var store = Store(api, socket, queryParams);
    return props => {
        return <Controller
            {...props}
            store={store.state}
            actions={store.actions}
        />;
    }
};
